
const $inject = ['$q', 'dataService', '$timeout', '$rootScope','$http'];

const companyReferenceService = function ($q, dataService, $timeout, $rootScope,$http) {
  var service = {};

  service.saveCompanyReferences = saveCompanyReferences;
  service.deleteCompanyReference = deleteCompanyReference;
  service.getCompanyReferences = getCompanyReferences;
  service.getCompanyReferenceItems = getCompanyReferenceItems;

  function deleteCompanyReference(item){
    let deferred = $q.defer();

    dataService.patch('CompanyReferences', { IsDeleted: true }, item.id).then(()=>{
      deferred.resolve({message: 'done'});
    });

    return deferred.promise;
  }



  function saveCompanyReferences(data, hideMessage) {
    let deferred = $q.defer();
    const url = `${endPointUrl}/api/CompanyReferenceList/Save`;
    const settings = {};
    
    if(!(hideMessage===true)){
      $rootScope.$broadcast('lbaToast:showToast', { message: `Posting data...`, messageType: 'waiting' });
    }
    

    $http.post(url, data, settings)
        .success(function (data, status, headers) {
          
          $rootScope.isSaved = true;
          if(!(hideMessage===true)){
            $rootScope.$broadcast('lbaToast:showToast', { message: `Data saved`, messageType: 'success' });
          }
            
            deferred.resolve(data);
        })
        .error(function (data, status) {
          
          console.error(data);
            if (status === 412) {
                $rootScope.$broadcast('lbaToast:showToast', { message: 'Data out of date - please refresh', messageType: 'error' });
            } else if (status === 400) {
                $rootScope.$broadcast('lbaToast:showToast', { message: `Provided data is not valid - please review the data`, messageType: 'error' });
            } else {
                $rootScope.$broadcast('lbaToast:showToast', { message: 'Error occurred', messageType: 'error' });
            }

            deferred.reject();
        });

    return deferred.promise;
};


  function getCompanyReferences(){
    let deferred = $q.defer();
    $http.get(`${endPointUrl}/api/CompanyReferenceList/CompanyReferenceSummary`)
    .success(function (data) {
      deferred.resolve(data);
    })
    .error(function (err, x) {
      deferred.reject(err);
    });
    return deferred.promise;
  }

  function getCompanyReferenceItems(DebtorIdentifier,ListId){
    if(!DebtorIdentifier || !ListId){
      return;
    }
    //http://localhost:7622/odata/CompanyReferences?$filter=DebtorIdentifier+eq+('THUNDERJR0')+and+ListId+eq+('Test')
    let query = `CompanyReferences?$filter=DebtorIdentifier+eq+('${encodeURI(DebtorIdentifier)}')+and+ListId+eq+('${encodeURI(ListId)}')+and+IsDeleted+eq+(false)`;
    let deferred = $q.defer();
    dataService.get(query).then((data) => {
      deferred.resolve(data);
    });
    return deferred.promise;
  }


  return service;
};

companyReferenceService.$inject = $inject;

export default companyReferenceService;



// WEBPACK FOOTER //
// ./src/services/companyReferenceService.js